import { render, staticRenderFns } from "./logisticsInformationInfoDialog.vue?vue&type=template&id=19ff5ea4&scoped=true"
import script from "./logisticsInformationInfoDialog.vue?vue&type=script&lang=js"
export * from "./logisticsInformationInfoDialog.vue?vue&type=script&lang=js"
import style0 from "./logisticsInformationInfoDialog.vue?vue&type=style&index=0&id=19ff5ea4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ff5ea4",
  null
  
)

export default component.exports